import { useSelect } from '@wordpress/data';
import {
    Typography,
    Grid,
    Card,
    CardContent
} from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

export const api = {
  BASE_URL: 'https://app.usetopic.com/api/',
  LOGIN_ENDPOINT: 'login',
  GET_BRIEFS:'keyword_reports/'
}

export const LOAD_BRIEF_PAGE_TEXT = {
    LOAD_BRIEF_HEADING: 'Load Brief',
    BRIEF_TEXTFIELD_LABAL_TEXT: 'Enter the URL to the Content Brief',
    BRIEF_TEXTFIELD_PLACEMENT_TEXT:'https://app.usetopic.com/briefs/xxxxxxx/overview',
    LOAD_BRIEF_BUTTON_TEXT:'GO',
    LOG_IN_BUTTON_TEXT:'Sign In',
    SNACKBAR_TEXT_INVALID:'Invalid URL, Please make sure brief is public'
}

export const LOGIN_PAGE_TEXTS = {
    SIGN_IN_TEXT: 'Sign In',
    EMAIL_TEXTFIELD_LABAL_TEXT: 'Email',
    EMAIL_TEXTFIELD_PLACEMENT_TEXT:'login@email.com',
    PASSWORD_TEXTFIELD_LABAL_TEXT: 'Password',
    PASSWORD_TEXTFIELD_PLACEMENT_TEXT:'*********',
    LOGIN_BUTTON_TEXT:'Log In',
    LOAD_BRIEF_BUTTON_TEXT:'Load Brief'
}

export const DASHBOARD_TEXTS = {
    SEARCH_BRIEF_TEXT_HEADING: 'Search Briefs',
    BRIEF_SUB_HEADING_TEXT: 'Your Content Briefs',
    BRIEF_HOVER_TOOLTIP_TEXT:'Select this Brief',
    BRIEF_LINK_TOOLTIP_TEXT:'View This Brief in Browser',
    BRIEF_SEARCH_PLACEHOLDER_TEXT:'Search briefs by keywords'
}

export const HEADER_TEXTS = {
    LOGGED_IN_TEXT: 'Signed in as',
    NOT_LOGGED_IN_TEXT: 'You are not signed in',
    LOGOUT_ICON_LABEL:'Logout',
    BACK_BUTTON_LABEL: 'Back'


}

export const FOOTER_UTILS = {
    TOPIC_LOGO_URL_LINK : 'https://www.usetopic.com',
    TOPIC_LOGO_LINK:'https://uploads-ssl.webflow.com/5d7bfb33d27da2d97219c009/5d927c199aec2843d190ea20_logo-rectangle.png',
    HELP_TXT_LINK: 'https://usetopic.zendesk.com/hc/en-us'
}

export const OUTLINE_UTILS = {
    HEADER_TEXT: 'Competitor Outlines',
    DESCRIPTION_TEXT_1:'Easily see how others are covering this topic so that you can quickly create your own outline.',
    DESCRIPTION_TEXT_2:'Why are some outlines missing?',
    OUTLINE_DESCRIPTION_TEXT:'DESCRIPTION',
    OUTLINE_OUTLINE_TEXT:'OUTLINE'
}

export const BRIEFS_UTIL= {
    CURRENT_GRADE_TEXT: 'Current Grade',
    WORD_COUNT_TEXT:'Word Count : ',
    SELECT_TOPIC_TEXT:'Topics',
    SELECT_QUESTIONS_TEXT:'Questions',
    SELECT_OUTLINES_TEXT:'Outlines'
}

export const QUESTIONS_UTIL = {
    NO_QUESTIONS_ERROR_TEXT:'No questions were found for ',
    HEADER: 'Questions To Answer',
    DESCRIPTION : 'Looking at commonly searched questions can help you understand what kind of answers your audience is looking for. Find natural ways to answer these questions in your content.',
    GOOGLE_QUESTIONS_TEXT_HEADER:'Google People Also Ask',
    QUORA_QUESTIONS_TEXT_HEADER:'Quora',
    QUORA_FOLLOW_COUNT_TEXT:'Follow Count : ',
    AUTOCOMPLETE_QUESTIONS_TEXT_HEADER:'Google Suggest',
    QUESTIONS_TEXT:'Question',

}

export const TOPIC_UTIL = {
    HEADER: 'Topics to Cover',
    SOURCES_TEXT_1:'used By',
    SOURCES_TEXT_2:'Sources'
}

export const FOOTER_TEXTS = {
    HELP_TXT: 'HELP'
}

export const GradeObject = {
  'F' : 1,
  'D-' : 2,
  'D' : 3,
  'D+' : 4,
  'C-' : 5,
  'C' : 6,
  'B-' : 7,
  'B' : 8,
  'B+': 9,
  'A-' : 10, 
  'A' : 11,
  'A+' : 12
}

//WP-BLOCKS Maps contents in the guttenberg editor and returns the value.
export function editorContent() {
  let contentStringArray = [];
  const Blocks = useSelect( ( select ) => {
    return select('core/block-editor').getBlocks()
  }, [] );

  Blocks.map((sBlock) => {
      if(sBlock.attributes && sBlock.attributes.content){
          contentStringArray.push(sBlock.attributes.content);
      }
  });
  return contentStringArray;
}

export function getHeadingCount(topic){
  let count = 0;
  topic.header_usage.map((heading) => {
      count += heading.sentences.length;
  });

  return count;
}

export function checkValidityOfBriefLink(id) {
  return new Promise((resolve,reject) => {
      fetch(api.BASE_URL+api.GET_BRIEFS+`${id}`, {
        method: 'GET',
      }).then(function(response) {
          return response.json();
      })
      .then(function(data) {
          if(!data.error){
            resolve(true);
          }else{
            resolve(false);
          }
      }).catch((err) =>{
          resolve(false);
      });
    });
  }


  export function generateOutline(text,tag){
    switch(tag){
        case 'H1':
            return (
                <Typography variant="subtitle2" style={{fontWeight:'700',color:'#3e4b5b'}}>{text}</Typography>
            );
        break;
        case 'H2':
            return (
                <Typography variant="subtitle2" style={{fontWeight:'700',color:'#3e4b5b'}}>{text}</Typography>
            );
        break;
        case 'H3':
            return (
                <Typography variant="body2" style={{color:'#3e4b5b',marginLeft:'1rem'}}>{text}</Typography>
            );
        break;
        case 'H4':
            return (
                <Typography variant="body2" style={{color:'#3e4b5b',marginLeft:'1.3rem'}}>{text}</Typography>
            );
        break;
        case 'H5':
            return (
                <Typography variant="body2" style={{color:'#3e4b5b',marginLeft:'1.5rem'}}>{text}</Typography>
            );
        break;
        case 'H6':
            return (
                <Typography variant="body2" style={{color:'#3e4b5b',marginLeft:'1.6rem'}}>{text}</Typography>
            );
        break;
        default:
            return (
                <Typography variant="body2" style={{color:'#3e4b5b',marginLeft:'1.6rem'}}>{text}</Typography>
            );
    }
}

export function getCustomStyle (selector) {
    switch(selector){
        case '#sidebar':
            return (
                <style>{"\
                .edit-post-sidebar{\
                    width: 24rem;\
                    padding-bottom:unset!important;\
                }\
                body{\
                    overflow:hidden;\
                }\
                .topic-sidebar.components-panel{\
                    height:100%\
                }\
                "}</style>
            );
        break;
        default:
            return
    }
}

export function loadSkeleton (type) {
    switch(type){
        case 'card':
            return (
                <Grid xs="12">
                    <Card style={{marginBottom:'1rem',borderRadius:'0.5rem'}}>
                        <CardContent>
                            <Skeleton/>
                            <Skeleton/>
                            <Skeleton/>
                        </CardContent>
                    </Card>
                    <Card style={{marginBottom:'1rem',borderRadius:'0.5rem'}}>
                        <CardContent>
                            <Skeleton/>
                            <Skeleton/>
                            <Skeleton/>
                        </CardContent>
                    </Card>
                    <Card style={{marginBottom:'1rem',borderRadius:'0.5rem'}}>
                        <CardContent>
                            <Skeleton/>
                            <Skeleton/>
                            <Skeleton/>
                        </CardContent>
                    </Card>
                </Grid>
            )
        break;
        case 'text':
            return(
                <Typography variant="h3">
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                    <br/>
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                    <br/>
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                    <br/>
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                    <br/>
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                </Typography>
            );
        break;
        default:
            return;
        break;
    }
}
